import React, { useState } from 'react';
import Layout from '../components/Layout';

function RFRManagement({ user, onLogout }) {
  const [rfrList, setRfrList] = useState([]);

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Ready for Repair (RFR)</h1>
          <p className="text-gray-600 mt-2">Manage and issue RFR documents</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Total RFRs</p>
            <p className="text-2xl font-bold text-gray-800">{rfrList.length}</p>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Pending Issue</p>
            <p className="text-2xl font-bold text-yellow-600">0</p>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Issued Today</p>
            <p className="text-2xl font-bold text-green-600">0</p>
          </div>
        </div>

        {/* Create RFR Button */}
        <div className="mb-6">
          <button className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-semibold">
            + Create New RFR
          </button>
        </div>

        {/* RFR List */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">RFR ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Device Count</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Engineer</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {rfrList.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                    No RFRs created yet
                  </td>
                </tr>
              ) : (
                rfrList.map((rfr, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap font-medium">{rfr.id}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{rfr.deviceCount}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{rfr.engineer}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                        {rfr.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">{rfr.created}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button className="text-blue-600 hover:text-blue-800 mr-2">View</button>
                      <button className="text-green-600 hover:text-green-800">Issue</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

export default RFRManagement;
